var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"blog-section__grid"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"blog-section__grid-item"},[_c(_setup.BlogSectionSimpleItem,{attrs:{"item":item,"data-test":"item"},on:{"click":function($event){return _setup.onItemClick(i)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }